import React from 'react';
import './Header.css';
import { translateUiText } from '../i18n';

const Header = ({ title, leftIcon, rightIcon, onRightIconClick, locale = 'en' }) => {
  return (
    <div className="header-container">
      {leftIcon && (
        <img
          src={leftIcon}
          alt={translateUiText(locale, 'alertIconAlt')}
          className="icon-style"
        />
      )}
      <p className="header-title">{title}</p>
      {rightIcon && (
        <img
          src={rightIcon}
          alt={translateUiText(locale, 'languageIconAlt')}
          className="icon-style clickable"
          onClick={onRightIconClick}
        />
      )}
    </div>
  );
};

export default Header;
